import { defineStore } from 'pinia'
import { getMerchantInfo } from '@/api/merchant.js'
import { useAuthStore } from './auth'

export const useMerchantStore = defineStore('merchant', {
  state: () => ({
    merchants: {},
    addressDirtySave: {},
    showSelectModal: false,
    selectModalIsClosable: false,
    searchFilter: ''
  }),

  getters: {
    byIdent: (state) => (ident) => {
      return state.merchants[ident]
    },

    isAddressDirtySave: (state) => (ident) => {
      return Object.keys(state.addressDirtySave).includes(ident) || false
    }
  },

  actions: {
    async getMerchantInfo(ident) {
      const fromCache = this.byIdent(ident)
      if (fromCache) {
        return fromCache
      }

      const fromAPI = await getMerchantInfo(ident)
      if (fromAPI) {
        this.merchants[fromAPI.uuid] = fromAPI
        return fromAPI
      }
    },

    async setCurrentFromIdent(ident) {
      const m = await getMerchantInfo(ident)
      if (m && m.uuid) {
        this.merchants[m.uuid] = m

        const authStore = useAuthStore()
        authStore.setCurrentMerchant({ merchant: m })
        return true
      } else {
        return false
      }
    },

    showMerchantSelectModal(opts) {
      this.selectModalIsClosable = opts.closable || false

      if (opts.filter) {
        this.searchFilter = opts.filter
      }

      if (opts.show) {
        this.showSelectModal = true
      } else {
        this.showSelectModal = false
      }
    },

    setAddressDirtySave(ident) {
      this.addressDirtySave[ident] = { dirty: true }
    }
  }
})
